export const lookbook = [
    {
        name: "bobby-soft-mint",
        productId: "214703",
        offerId: "214714",
        type: "one",
        dot: {
            x: 67,
            y: 58,
            tooltip: "right-top",
        },
    },
    {
        name: "bobby-hero-xl-grey",
        productId: "193153",
        offerId: "193932",
        type: "two",
        dot: {
            x: 43,
            y: 31,
            tooltip: "left-bottom",
        },
    },
    {
        name: "flex-gym-bag",
        productId: "212444",
        // offerId: "212456",
        type: "three",
        dot: {
            x: 72,
            y: 60,
            tooltip: "right-top",
        },
    },
    {
        name: "bobby-bizz",
        productId: "82767",
        // offerId: "82791",
        type: "two",
        dot: {
            x: 43,
            y: 33,
            tooltip: "right-bottom",
        },
    },
    {
        name: "bobby-hero-spring-pink",
        productId: "210821",
        offerId: "210835",
        type: "three",
        dot: {
            x: 52,
            y: 67,
            tooltip: "right-top",
        },
    },
    {
        name: "bobby-soft-brown",
        productId: "214703",
        offerId: "214712",
        type: "four",
        dot: {
            x: 77,
            y: 38,
            tooltip: "left-bottom",
        },
    },
    {
        name: "bobby-hero-regular-green",
        productId: "192981",
        offerId: "192986",
        type: "two",
        dot: {
            x: 59,
            y: 33,
            tooltip: "right-top",
        },
    },
    {
        name: "bobby-sling-black",
        productId: "213677",
        offerId: "213678",
        type: "three",
        dot: {
            x: 45,
            y: 40,
            tooltip: "left-top",
        },
    },
    {
        name: "bobby-hero-regular-grey",
        productId: "192981",
        offerId: "192983",
        type: "two",
        dot: {
            x: 48,
            y: 55,
            tooltip: "right-top",
        },
    },
];
